export default "__VITE_ASSET__CA$dB0Km__"